import { Button, ButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { IsTenantAdministrator } from 'components/helpers/IsTenantAdministrator';
import TenantPage from 'components/common/TenantPage';
import { regionalRateService } from 'services/api';
import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { RegionalRateColumns } from 'components/common/enhanced/common-headers';

export const RegionalRates = () => {
  const translationPrefix = 'pages.regional-rate.list';

  const { t } = useTranslation();

  const columns: GridColDef[] = RegionalRateColumns();

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.title`)}
        subtitle={t(`${translationPrefix}.subtitle`)}
        menuRight={
          <div className="flex justify-end items-center">
            <ButtonGroup>
              <IsTenantAdministrator>
                <Link to="new">
                  <Button color="primary" size="small">
                    <AddIcon />
                    {t(`${translationPrefix}.add-new`)}
                  </Button>
                </Link>
              </IsTenantAdministrator>
            </ButtonGroup>
          </div>
        }>
        <div className="mt-6">
          <EnhancedDataGrid columns={columns} service={regionalRateService} />
        </div>
      </TenantPage>
    </>
  );
};

export default RegionalRates;
